(function () {
    var controllerId = 'revenue.views.corporates.index';
    var module = angular.module('revenue');

    module.controller(controllerId, function () {
        // EMPTY
    });
})();
